export default "__VITE_ASSET__O9YHJMc0__"